__turbopack_context__.v({
  "item": "3d-models-module-scss-module__SRfqJq__item",
  "list": "3d-models-module-scss-module__SRfqJq__list",
  "lockedItem": "3d-models-module-scss-module__SRfqJq__lockedItem",
  "padlock": "3d-models-module-scss-module__SRfqJq__padlock",
});
